<template>
  <div class="page-enterprise">
    <div class="page-contentB">
      <a-layout>
        <div class="page-bHder">
          <a-layout-header>
            <div class="page-tabB">
              <a-tabs :activeKey="tabKey" @change="callbackBasic">
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.General_Information')"
                  key="1"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.Security_Level')"
                  key="2"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.Company_Profile')"
                  key="3"
                ></a-tab-pane>
              </a-tabs>
            </div>
          </a-layout-header>
        </div>
        <div class="page-coBasic">
          <a-layout-content>
            <div class="enterprise-title">
              <img src="./images/bookmark.png" />
              <span>{{ $tc('lang.UserCenter.Company_Profile_t') }}</span>
            </div>
            <div class="enterprise-con">
              <div class="entCon-left">
                <a-form :form="form" @submit="handleSubmit">
                  <a-form-item
                    :label="$tc('lang.UserCenter.Photo')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                  >
                    <a-upload
                      :data="upledData"
                      :action="config.urlImg + urlName"
                      :fileList="fileList"
                      listType="picture-card"
                      @preview="handlePreview"
                      @change="handleUpload"
                      :multiple="true"
                    >
                      <div v-if="fileList.length < 1">
                        <a-icon type="plus" />
                      </div>
                    </a-upload>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.UserCenter.Company_Name')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                  >
                    <a-input
                      :placeholder="$tc('lang.UserCenter.please_company_name')"
                      v-decorator="[
                        'personCompanyname',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc(
                                'lang.UserCenter.please_company_name',
                              ),
                            },
                          ],
                        },
                      ]"
                    >
                    </a-input>
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.UserCenter.Region')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                  >
                    <a-cascader
                      :options="preCiy"
                      :placeholder="$tc('lang.UserCenter.Please_region')"
                      @change="onAreaChange"
                      changeOnSelect
                      v-decorator="[
                        'orderFactoryarea',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc('lang.UserCenter.Please_region'),
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.UserCenter.Sepecific_Add')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                  >
                    <a-input
                      :placeholder="$tc('lang.UserCenter.Please_ADD')"
                      v-decorator="[
                        'personAddress',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc('lang.UserCenter.Please_ADD'),
                            },
                          ],
                        },
                      ]"
                    >
                    </a-input>
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.UserCenter.Contact_Name')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                  >
                    <a-input
                      :placeholder="$tc('lang.UserCenter.Contact_Name')"
                      v-decorator="[
                        'personContactname',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc(
                                'lang.UserCenter.Please_contact_name',
                              ),
                            },
                          ],
                        },
                      ]"
                    >
                    </a-input>
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.UserCenter.Mobile_Number')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                  >
                    <a-input
                      :placeholder="$tc('lang.UserCenter.Mobile_Number')"
                      disabled
                      v-decorator="[
                        'personMobilephone',
                        // {
                        //   rules: [
                        //     {
                        //       required: true,
                        //       message: 'Please select your gender!',
                        //     },
                        //   ],
                        // },
                      ]"
                    >
                    </a-input>
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.UserCenter.Telephone_Number')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                  >
                    <a-input
                      :placeholder="$tc('lang.UserCenter.Telephone_Number')"
                      v-decorator="[
                        'personFixedtel',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc('lang.UserCenter.Please_Tel_Number'),
                            },
                          ],
                        },
                      ]"
                    >
                    </a-input>
                  </a-form-item>
                </a-form>
              </div>
              <div class="entCon-right">
                <a-form :form="form" @submit="handleSubmit">
                  <a-form-item
                    :label="$tc('lang.UserCenter.Licence_registration')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                  >
                    <a-input
                      :placeholder="
                        $tc('lang.UserCenter.Please_License_Number')
                      "
                      v-decorator="[
                        'personLicenseid',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc(
                                'lang.UserCenter.Please_License_Number',
                              ),
                            },
                          ],
                        },
                      ]"
                    >
                    </a-input>
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.UserCenter.Licence')"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                    class="upload"
                  >
                    <a-upload
                      :data="uplodDataOne"
                      :action="config.urlImg + urlName"
                      :fileList="fileListOne"
                      listType="picture-card"
                      @preview="handlePreviewOne"
                      @change="handleChangeOne"
                      :multiple="true"
                    >
                      <div>
                        <a-icon type="plus" />
                      </div>
                    </a-upload>
                    <a-modal
                      :visible="previewVisibleOne"
                      :footer="null"
                      @cancel="handleCancel1"
                    >
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImageOne"
                      />
                    </a-modal>
                    <p>{{ $tc('lang.UserCenter.update_imaeg_text') }}</p>
                    <p>{{ $tc('lang.UserCenter.Company_text') }}</p>
                  </a-form-item>
                  <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                    <div class="page-gdSubmit">
                      <a-button type="primary" @click="handleSubmit">
                        {{ $tc('lang.UserCenter.Submit') }}
                      </a-button>
                    </div>
                  </a-form-item>
                </a-form>
              </div>
            </div>
          </a-layout-content>
        </div>
      </a-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: 'enterprise',
  data() {
    return {
      tabKey: '3',
      formLayout: 'horizontal',

      form: this.$form.createForm(this),

      previewVisible: false,
      previewImage: '',
      // 头像信息
      upledData: {
        mediaName: '客户头像',
        mediaType: '2',
        mediaDesc: 'person_headphoto',
        // personId: '1',
      },
      // 头像
      fileList: [],
      // 全部用户数据
      userInfoMap: null,
      // 营业执照
      previewVisibleOne: false,
      previewImageOne: '',
      fileListOne: [],
      uplodDataOne: {
        mediaName: '营业执照',
        mediaType: '2',
        mediaDesc: 'person_headphoto',
        // personId: '1',
      },
      // 全部表单数据
      tableFromData: {},
      user: {},
      userSession: {},
      urlName: '/hzwmj/media/fileUpload',
    };
  },
  // 数据状态处理全局
  computed: {
    // 城市联动
    preCiy: {
      get() {
        return this.$store.state.downOrder.preCiy;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          preCiy: value,
        });
      },
    },
  },
  created() {
    // 查询城市联动
    this.$store.dispatch('downOrder/queryPreCiy');
    // 查询用户信息
    this.handleUserBasicData();
    // 获取用户sessionStorage信息
    if (sessionStorage.getItem('user') !== null) {
      this.userSession = JSON.parse(sessionStorage.getItem('user')) || {};
    }
  },
  methods: {
    /*基本信息,安全等级,企业资料:路由切换跳转路径*/
    callbackBasic(key) {
      console.log(key);
      if (key === '1') {
        this.$router.push('/basic');
      }
      if (key === '2') {
        this.$router.push('/safeGrade');
      }
      if (key === '3') {
        this.$router.push('/enterprise');
      }
    },
    /*所在区域联动*/
    onAreaChange(value) {
      console.log(value);
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleUserBasicData() {
      // 获取用户session信息
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
      this.$http
        .post('/hzwmj/person/getPersonById', {
          personId: this.user.id,
        })
        .then(data => {
          if (data.code === 200) {
            console.log('data=====', data);
            const userData = data.data;
            this.form.setFieldsValue({
              personCompanyname: userData.personCompanyname,
              personAddress: userData.personAddress,
              personContactname: userData.personContactname,
              personMobilephone: userData.personMobilephone,
              personLicenseid: userData.personLicenseid,
              personFixedtel: userData.personFixedtel,
              orderFactoryarea:
                userData.personLocation !== null
                  ? userData.personLocation.split('/')
                  : [],
            });
            if (
              userData.personHeadphotoList !== undefined &&
              userData.personHeadphotoList !== null
            ) {
              if (userData.personHeadphotoList.length !== 0) {
                userData.personHeadphotoList.forEach(value => {
                  const urlPath = this.config.urlImg + value.mediaPath;
                  this.fileList.push({
                    uid: value.id,
                    name: value.mediaName,
                    url: urlPath,
                    status: 'done',
                  });
                });
              }
            }
            if (
              userData.personLicensephotoList !== undefined &&
              userData.personLicensephotoList !== null
            ) {
              if (userData.personLicensephotoList.length !== 0) {
                userData.personLicensephotoList.forEach(value => {
                  const urlPath = this.config.urlImg + value.mediaPath;
                  this.fileListOne.push({
                    uid: value.id,
                    name: value.mediaName,
                    url: urlPath,
                    status: 'done',
                  });
                });
              }
            }
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {
          this.$message.error('系统异常');
        });
    },
    /*删除上传头像*/
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    /*上传头像*/
    handleUpload(info) {
      let fileList = [...info.fileList];
      // 从响应读取并显示文件链接
      fileList = fileList.map(file => {
        if (file.response) {
          // 组件将file.url显示为链接
          file.url = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;
      // this.fileList = fileList;
    },
    handleCancel1() {
      this.previewVisibleOne = false;
    },
    // 删除营业执照
    handlePreviewOne(file1) {
      this.previewImageOne = file1.url || file1.thumbUrl;
      this.previewVisibleOne = true;
    },
    // 上传营业执照
    handleChangeOne({ fileList }) {
      let list = [...fileList];
      // 从响应读取并显示文件链接
      list = list.map(file => {
        if (file.response) {
          // 组件将file.url显示为链接
          file.url = file.response.url;
        }
        return file;
      });

      this.fileListOne = list;
    },
    // 遍历生产订单上传附件的ID
    onFileList() {
      let file = [];
      const fileList = this.fileList;
      console.log('fileList', fileList);
      if (fileList.length > 0) {
        fileList.forEach(value => {
          console.log('value.response1', value.response);
          value.response !== undefined
            ? file.push(value.response.data.object.id)
            : file.push(String(value.uid));
        });
        return file.join(',');
      } else {
        return '';
      }
    },
    Licensephoto() {
      let file = [];
      const fileList = this.fileListOne;
      console.log('fileList', fileList);
      if (fileList.length > 0) {
        fileList.forEach(value => {
          console.log('value.response2', value.response);
          value.response !== undefined
            ? file.push(value.response.data.object.id)
            : file.push(String(value.uid));
        });
        return file.join(',');
      } else {
        return '';
      }
    },
    // 公司数据提交
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.tableFromData = {
            personLocation: values.orderFactoryarea,
            personAddress: values.personAddress,
            personCompanyname: values.personCompanyname,
            personContactname: values.personContactname,
            personFixedtel: values.personFixedtel,
            personLicenseid: values.personLicenseid,
            personHeadphoto: this.onFileList(),
            personLicensephoto: this.Licensephoto(),
            userType: 1,
            personId: this.userSession.id,
            type: 8,
          };
          this.$store.dispatch('user/updatePersonMassage', this.tableFromData);
        }
      });
    },
  },
};
</script>

<style lang="less">
.page-enterprise {
  .page-contentB {
    border-left: 1px solid #f0f2f5;
    border-right: 1px solid #f0f2f5;
    border-bottom: 1px solid #f0f2f5;
    border-radius: 10px;
    margin-top: 3%;
    .ant-layout {
      height: calc(100vh - 209px);
      background-color: #fff;
    }
    .ant-col-5 {
      width: 30%;
    }
    .page-bHder {
      .ant-layout-header {
        padding: 0 25px;
        background-color: #fff;
        height: 44px;
      }
    }
    .page-tabB {
      .ant-tabs-nav .ant-tabs-tab-active {
        background-color: #e9eef3;
      }
      .ant-tabs-nav {
        float: left;
      }
    }
    .page-coBasic {
      overflow-y: auto;
      text-align: left;
      padding: 20px 40px;
      background-color: #ffffff;
      // width: 89%;
    }
    .enterprise-title {
      padding-bottom: 15px;
      border-bottom: 1px solid #c9c9c9;
      img {
        width: 34px;
      }
      span {
        margin-left: 20px;
        font-size: 26px;
        vertical-align: middle;
      }
    }
    .enterprise-con {
      margin-top: 20px;
      .ant-form-item-label {
        text-align: left;
      }
      display: flex;
      .entCon-left {
        width: 50%;
        .ant-upload-list-picture-card .ant-upload-list-item {
          width: 60px;
          height: 60px;
          padding: 2px;
          margin: 0px;
        }
        .ant-upload.ant-upload-select-picture-card {
          width: 60px;
          height: 60px;
          // padding: 2px;
          margin: 0px;
        }
        .ant-upload-select-picture-card i {
          font-size: 32px;
          color: #999;
        }

        .ant-upload-select-picture-card .ant-upload-text {
          font-size: 12px;
          margin-top: 8px;
          color: #666;
        }
      }
      .entCon-right {
        width: 50%;
        .upload {
          p {
            font-size: 12px;
            margin-bottom: 0;
            line-height: 28px;
          }
        }

        .ant-upload-list-picture-card .ant-upload-list-item {
          width: 100%;
          height: 150px;
          padding: 2px;
          margin: 0px;
        }
        .ant-upload.ant-upload-select-picture-card {
          width: 100%;
          height: 150px;
          // padding: 2px;
          margin: 0px;
        }
        .ant-upload-select-picture-card i {
          font-size: 32px;
          color: #999;
        }
        .ant-upload-select-picture-card .ant-upload-text {
          margin-top: 8px;
          color: #666;
        }
      }
    }
  }
}
</style>
